import { render, staticRenderFns } from "./LandparcelBI.vue?vue&type=template&id=4809f2b9&lang=html&"
import script from "./LandparcelBI.vue?vue&type=script&lang=js&"
export * from "./LandparcelBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports